import { Phone } from 'lucide-react';
import { restaurantInfo } from '../data/menuData';

export const FloatingCallButton = () => {
  return (
    <a
      href={restaurantInfo.phoneLink}
      className="fixed bottom-6 right-6 z-50 md:hidden bg-green-600 hover:bg-green-700 text-white rounded-full p-4 shadow-2xl pulse-ring transition-transform hover:scale-110"
      data-testid="floating-call-button"
      aria-label="Appeler pour commander"
    >
      <Phone className="w-6 h-6" />
    </a>
  );
};

export default FloatingCallButton;
